export default __webpack_public_path__ + "static/media/bg-pattern-header.ea1134f1.svg";